import _ from 'lodash';
import moment from 'moment';

import { ascNegativeLastSort, ascSort } from '../declarative/sortings';

export function GetArraySport(data = {}) {
  const sportArray = Object.entries(data)
    .filter(([, value]) => Boolean(value))
    .map(([key, sport]) => ({
      id: sport.id || +key,
      name: sport.name,
      order: sport.order,
      alias: sport.alias,
      game: sport.game,
      region: sport.region,
    }));

  return sportArray.sort(ascNegativeLastSort('order'));
}
export function GetArrayRegion(data = {}, sortKey = null) {
  const regionArray = Object.entries(data)
    .filter(([, value]) => Boolean(value))
    .map(([key, region]) => ({
      id: region.id || +key,
      name: region.name,
      order: region.order,
      alias: region.alias,
      game: region.game,
      competition: region.competition,
    }));

  return regionArray.sort(sortKey ? ascSort(sortKey) : ascNegativeLastSort('order'));
}

export function GetArrayCompetition(data = {}, sortKey = null) {
  const competitionArray = Object.entries(data)
    .filter(([, value]) => Boolean(value))
    .map(([key, competition]) => ({
      id: competition.id || +key,
      name: competition.name,
      order: competition.order,
      game: competition.game,
      favorite_order: competition.favorite_order,
    }));
  return competitionArray.sort(sortKey ? ascSort(sortKey) : ascNegativeLastSort('order'));
}

export function GetArrayRegionCompetition(data = {}, sortKey = null) {
  const result = GetArrayRegion(data).reduce((acc, region) => {
    GetArrayCompetition(region.competition).map((competition) => acc.push({ ...competition, region }));

    return acc;
  }, []);

  return result.sort(sortKey ? ascSort(sortKey) : ascNegativeLastSort('order'));
}

export function wrapNestedParentSelections(data, result) {
  return Object.entries(data)
    .reduce((acc, [key, value]) => {
      if (key.startsWith('#')) {
        const parentName = key.slice(1, key.indexOf(':'));
        const parentKeyName = key.slice(key.indexOf(':') + 1);

        acc[parentName] = {
          ...(acc[parentName] || {}),
          [parentKeyName]: value,
        };
      }

      return acc;
    }, result);
}

export function GetArrayGame(data = {}, sortKey = null, groupKey = null) {
  const gameArray = Object.entries(data)
    .filter(([, value]) => Boolean(value))
    .map(([key, game]) => wrapNestedParentSelections(game, {
      id: game.id || +key,
      type: game.type,
      tv_type: game.tv_type,
      video_id: game.video_id,
      is_stat_available: game.is_stat_available,
      stats: game.stats,
      info: game.info,
      order: game.order,
      team1_name: game.team1_name,
      team2_name: game.team2_name,
      team1_id: game.team1_id,
      team2_id: game.team2_id,
      start_ts: game.start_ts,
      sport_alias: game.sport_alias,
      is_live: game.is_live,
      is_blocked: game.is_blocked,
      markets_count: game.markets_count,
      market: game.market,
      round: game.round,
      game_number: game.game_number,
      start_ts_date: moment.unix(game.start_ts).startOf("day").valueOf(),
      sportcast_id: game.sportcast_id,
      sportId: game.sport?.id,
      region_alias: game.region_alias || game.region?.alias,
      regionId: game.region?.id,
      competition: game.competition,
      competitionId: game.competition?.id,
      competitionName: game.competition?.name,
      game_info: game.game_info,
      event: game.event,
    }));

  if (groupKey) {
    const groupedGames = _.groupBy(gameArray, groupKey);
    return _.mapValues(groupedGames, (value) => value.sort(sortKey ? ascSort(sortKey) : ascNegativeLastSort('order')));
  }

  return gameArray.sort(sortKey ? ascSort(sortKey) : ascNegativeLastSort('order'));
}

export function GetArrayMarket(data = {}, sortKey = null) {
  const marketArray = Object.entries(data)
    .filter(([, value]) => Boolean(value))
    .map(([key, market]) => ({
      id: market.id || +key,
      type: market.type,
      name: market.name,
      market_type: market.market_type,
      display_key: market.display_key,
      display_sub_key: market.display_sub_key,
      express_id: market.express_id,
      sequence: market.sequence,
      base: market.base,
      has_early_payout: market.has_early_payout,
      is_new: market.is_new,
      order: market.order,
      event: market.event,
      alt_main_order: market.alt_main_order,
      group_name: market.group_name,
      cashout: market.cashout,
      col_count: market.col_count,
      extra_info: market.extra_info,
    }));

  return marketArray.sort(sortKey ? ascSort(sortKey) : ascNegativeLastSort('order'));
}

export function GetArrayEvent(data = {}, sortKey = null) {
  const eventArray = Object.entries(data)
    .filter(([, value]) => Boolean(value))
    .map(([key, event]) => ({
      id: event.id || +key,
      name: event.name,
      type: event.type,
      price: event.price,
      order: event.order,
      nonrunner: event.nonrunner,
      original_order: event.original_order,
      base: event.base,
      market: event.market,
    }));
  return eventArray.sort(sortKey ? ascSort(sortKey) : ascNegativeLastSort('order'));
}
